import { Link } from "react-router-dom";
import { useConsent } from "@/context/ConsentContext";

export default function ConsentBanner() {
  const { consent, acceptNecessary, acceptExternalMedia } = useConsent();

  if (consent) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie- und Datenschutzhinweis"
      className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-2xl rounded-xl border border-[#27272A] bg-[#16161A]/95 p-5 shadow-2xl backdrop-blur-xl sm:inset-x-6"
      data-testid="consent-banner"
    >
      <p className="text-sm leading-relaxed text-[#F5F5F3]">
        <strong className="font-semibold">Kurz & ehrlich:</strong> Wir verwenden nur technisch
        notwendige Speicherung (z.&nbsp;B. deine Auswahl hier). Externe Inhalte wie Google&nbsp;Maps
        werden erst geladen, wenn du zustimmst. Details im{" "}
        <Link to="/datenschutz" className="text-[#F54855] underline-offset-4 hover:underline" data-testid="consent-link-datenschutz">
          Datenschutz
        </Link>
        .
      </p>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
        <button
          type="button"
          onClick={acceptExternalMedia}
          className="inline-flex min-h-[44px] flex-1 items-center justify-center rounded-lg bg-[#E11D2A] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#F02837]"
          data-testid="consent-accept-media"
        >
          Erlauben
        </button>
        <button
          type="button"
          onClick={acceptNecessary}
          className="inline-flex min-h-[44px] flex-1 items-center justify-center rounded-lg border border-[#27272A] px-4 py-2 text-sm font-semibold text-[#F5F5F3] transition-colors hover:border-[#E11D2A]/40 hover:bg-[#1E1E24]"
          data-testid="consent-accept-necessary"
        >
          Nur notwendige
        </button>
      </div>
    </div>
  );
}
